import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import MarkEmailUnreadRoundedIcon from '@mui/icons-material/MarkEmailUnreadRounded';
import RateReviewRoundedIcon from '@mui/icons-material/RateReviewRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';

export const ADMIN_SECTIONS = Object.freeze([
  {
    id: 'admin-dashboard',
    route: '/dashboard/admin-dashboard',
    title: 'Admin Paneli',
    description: 'Genel istatistikler ve sistem özeti',
    tone: 'blue',
    icon: DashboardRoundedIcon,
  },
  {
    id: 'admin-kullanicilar',
    route: '/dashboard/admin-kullanicilar',
    title: 'Kullanıcılar',
    description: 'Kullanıcı yönetimi ve ayarları',
    tone: 'emerald',
    icon: GroupsRoundedIcon,
  },
  {
    id: 'admin-destek',
    route: '/dashboard/admin-destek',
    title: 'Destek Yönetimi',
    description: 'Destek talepleri ve mesaj yönetimi',
    tone: 'pink',
    icon: SupportAgentRoundedIcon,
  },
  {
    id: 'admin-yorumlar',
    route: '/dashboard/admin-yorumlar',
    title: 'Yorumlar',
    description: 'Yorum moderasyonu ve yönetimi',
    tone: 'orange',
    icon: RateReviewRoundedIcon,
  },
  {
    id: 'admin-raporlar',
    route: '/dashboard/admin-raporlar',
    title: 'Raporlar',
    description: 'İstatistikler ve analiz raporları',
    tone: 'indigo',
    icon: AnalyticsRoundedIcon,
  },
  {
    id: 'admin-hizli-cevaplar',
    route: '/dashboard/admin-hizli-cevaplar',
    title: 'Hızlı Cevaplar',
    description: 'Destek için hazır mesaj şablonları',
    tone: 'amber',
    icon: ChatRoundedIcon,
  },
  {
    id: 'admin-toplu-islemler',
    route: '/dashboard/admin-toplu-islemler',
    title: 'Toplu İşlemler',
    description: 'Çoklu işlemler ve otomasyon',
    tone: 'violet',
    icon: FactCheckRoundedIcon,
  },
  {
    id: 'admin-mail-kampanyalari',
    route: '/dashboard/admin-mail-kampanyalari',
    title: 'Mail Kampanyaları',
    description: 'Mail listeleri ve planlı gönderimler',
    tone: 'orange',
    icon: ForwardToInboxRoundedIcon,
  },
  {
    id: 'admin-odeme-kurtarma',
    route: '/dashboard/admin-odeme-kurtarma',
    title: 'Ödeme Kurtarma',
    description: 'Başarısız ödemeler ve korumalı mail takibi',
    tone: 'emerald',
    icon: MarkEmailUnreadRoundedIcon,
  },
  {
    id: 'admin-uygulama-ayarlari',
    route: '/dashboard/admin-uygulama-ayarlari',
    title: 'Uygulama Ayarları',
    description: 'Android, iOS ve LG uygulama ayarları',
    tone: 'green',
    icon: AppsRoundedIcon,
  },
  {
    id: 'admin-ayarlar',
    route: '/dashboard/admin-ayarlar',
    title: 'Ayarlar',
    description: 'Sistem ve uygulama ayarları',
    tone: 'slate',
    icon: SettingsRoundedIcon,
  },
]);

export const ADMIN_ROUTE_MAP = Object.freeze(
  Object.fromEntries(ADMIN_SECTIONS.map(({ id, route }) => [id, route])),
);

export const ADMIN_SECTION_IDS = Object.freeze(
  ADMIN_SECTIONS.map(({ id }) => id),
);
